import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import { Sales_Crm_Web_Common_Gof_FragmentFragmentDoc } from '@flowwai-frontend/bps-officer-web/graphql-docs'
import { AssigneeFieldMapping_FragmentFragmentDoc } from '@flowwai-frontend/bps-officer-web/graphql-docs'
import * as Apollo from '@apollo/client'
export type GetContactTemplateQueryVariables = Types.Exact<{
   [key: string]: never
}>

export type GetContactTemplateQuery = {
   __typename?: 'Query'
   getUserAppConfig: {
      __typename?: 'UserAppConfig'
      contactTemplate: {
         __typename?: 'ContactTemplate'
         contactTemplateId: string
         name: string
         accountId: string
         identificationFieldIds: Array<string>
         gofs: Array<{
            __typename?: 'GoF'
            gofId: string
            name: string
            description?: string | null
            orderedFieldIds: Array<string>
            category: Types.GoFCategory
            enableAddAnother: boolean
            addAnotherGofResponsesLimit?: number | null
            fields: Array<
               | {
                    __typename?: 'CheckboxGroupField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    options: Array<string>
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    multiStringDefaultValue: Array<string>
                 }
               | {
                    __typename?: 'DateField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    isDependent: boolean
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    dateFieldDefaultValue?: string | null
                    relativeDefaultValueConfig?: {
                       __typename?: 'DateRelativeDefaultValueConfig'
                       operator: Types.ArithmeticOperation
                       noOfDays: number
                       DateValueEnum: Types.DateValueEnum
                    } | null
                 }
               | {
                    __typename?: 'DateTimeField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    dateTimeDefaultValue?: string | null
                    relativeDefaultValueConfig?: {
                       __typename?: 'DateTimeRelativeDefaultValueConfig'
                       dateConfig?: {
                          __typename?: 'DateRelativeDefaultValueConfig'
                          operator: Types.ArithmeticOperation
                          noOfDays: number
                          DateValueEnum: Types.DateValueEnum
                       } | null
                       timeConfig?: {
                          __typename?: 'TimeRelativeDefaultValueConfig'
                          operator: Types.ArithmeticOperation
                          noOfSeconds: number
                          TimeValueEnum: Types.TimeValueEnum
                       } | null
                    } | null
                 }
               | {
                    __typename?: 'DropdownField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    options: Array<string>
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isLabelsEnabled: boolean
                    optionsValueType: Types.OptionsValueType
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
                    allowOtherOptions: boolean
                    stringDefaultValue?: string | null
                    optionColors: Array<{
                       __typename?: 'OptionColorConfig'
                       option: string
                       color: Types.ColorEnum
                    }>
                    conditionalOptions: Array<{
                       __typename?: 'ConditionalFieldOptions'
                       parentFieldId: string
                    }>
                 }
               | {
                    __typename?: 'EmailField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    regexErrorMessage?: string | null
                    validationRegex?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                 }
               | {
                    __typename?: 'FieldsSelectorField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    options: Array<string>
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
                    fieldSelectorFieldDefaultValue?: string | null
                    dependentFields: Array<{
                       __typename?: 'DependentFields'
                       option: string
                       dependentFieldIds: Array<string>
                    }>
                 }
               | {
                    __typename?: 'FileUploaderField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    allowedFormats: Array<string>
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    maxNumberOfFilesToUpload: number
                    eachFileMaxSizeInKb: number
                    canDownload: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                 }
               | {
                    __typename?: 'FloatField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isFormulaEnabled: boolean
                    iconId?: string | null
                    decimalPrecisionLimit?: number | null
                    tags: Array<Types.FieldTag>
                    floatDefaultValue?: number | null
                    rangeConfig?: {
                       __typename?: 'FloatRangeConfig'
                       floatMinValue?: number | null
                       floatMaxValue?: number | null
                    } | null
                 }
               | {
                    __typename?: 'GeoLocationField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    addressFieldIds: Array<string>
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                 }
               | {
                    __typename?: 'GeoShapeField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    variantType: Types.GeoShapeVariantType
                    addressFieldIds: Array<string>
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                 }
               | {
                    __typename?: 'IntegerField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isFormulaEnabled: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    intDefaultValue?: number | null
                    rangeConfig?: {
                       __typename?: 'IntegerRangeConfig'
                       intMinValue?: number | null
                       intMaxValue?: number | null
                    } | null
                 }
               | {
                    __typename?: 'LongTextField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isFormulaEnabled: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    regexErrorMessage?: string | null
                    validationRegex?: string | null
                    stringDefaultValue?: string | null
                 }
               | {
                    __typename?: 'MultiSelectField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    options: Array<string>
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isLabelsEnabled: boolean
                    optionsValueType: Types.OptionsValueType
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
                    allowOtherOptions: boolean
                    multiStringDefaultValue: Array<string>
                    optionColors: Array<{
                       __typename?: 'OptionColorConfig'
                       option: string
                       color: Types.ColorEnum
                    }>
                    conditionalOptions: Array<{
                       __typename?: 'ConditionalFieldOptions'
                       parentFieldId: string
                    }>
                 }
               | {
                    __typename?: 'PhoneNumberField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isIdentificationField: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                 }
               | {
                    __typename?: 'PlainTextField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    regexErrorMessage?: string | null
                    validationRegex?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isIdentificationField: boolean
                    isFormulaEnabled: boolean
                    autoGenerateApplicationIdInCreation: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                 }
               | {
                    __typename?: 'RadioGroupField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    options: Array<string>
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                 }
               | {
                    __typename?: 'RelationField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    salesTemplateId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    referenceId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    linkedSourceFieldId?: string | null
                    valueType: Types.RelationFieldValueType
                    parentFieldOptions?: {
                       __typename?: 'ParentFieldOptions'
                       options: Array<string>
                       parentFieldId: string
                    } | null
                    relation: {
                       __typename?: 'RelationOverviewDetails'
                       cardinality: Types.Cardinality
                       name: string
                       relationId: string
                       fromSalesTemplateConfig: {
                          __typename?: 'RelatedSalesTemplateOverviewDetails'
                          salesTemplateId: string
                          displayName: string
                          pipelineItemType?: Types.PipelineItemType | null
                          salesTemplateName: string
                          salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                       }
                       toSalesTemplateConfig: {
                          __typename?: 'RelatedSalesTemplateOverviewDetails'
                          salesTemplateId: string
                          salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                          displayName: string
                          pipelineItemType?: Types.PipelineItemType | null
                          salesTemplateName: string
                       }
                    }
                    secondDegreeRelation?: {
                       __typename?: 'RelationOverviewDetails'
                       cardinality: Types.Cardinality
                       name: string
                       relationId: string
                       fromSalesTemplateConfig: {
                          __typename?: 'RelatedSalesTemplateOverviewDetails'
                          salesTemplateId: string
                          displayName: string
                          pipelineItemType?: Types.PipelineItemType | null
                          salesTemplateName: string
                          salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                       }
                       toSalesTemplateConfig: {
                          __typename?: 'RelatedSalesTemplateOverviewDetails'
                          salesTemplateId: string
                          salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                          displayName: string
                          pipelineItemType?: Types.PipelineItemType | null
                          salesTemplateName: string
                       }
                    } | null
                 }
               | {
                    __typename?: 'ShortTextField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    regexErrorMessage?: string | null
                    validationRegex?: string | null
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    isUnique: boolean
                    isIdentificationField: boolean
                    isFormulaEnabled: boolean
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                    prefixOptions?: {
                       __typename?: 'PrefixOptions'
                       isEnabled: boolean
                       values: Array<string>
                       optionsValueType: Types.OptionsValueType
                       conditionalPrefixOptions: Array<{
                          __typename?: 'ConditionalFieldOptions'
                          parentFieldId: string
                          options: Array<{
                             __typename?: 'ConditionalOptions'
                             options: Array<string>
                             parentFieldOption: string
                          }>
                       }>
                    } | null
                    suffixOptions?: {
                       __typename?: 'SuffixOptions'
                       isEnabled: boolean
                       values: Array<string>
                    } | null
                 }
               | {
                    __typename?: 'TimeField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    isDependent: boolean
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    timeFieldDefaultValue?: string | null
                    relativeDefaultValueConfig?: {
                       __typename?: 'TimeRelativeDefaultValueConfig'
                       operator: Types.ArithmeticOperation
                       noOfSeconds: number
                       TimeValueEnum: Types.TimeValueEnum
                    } | null
                 }
               | {
                    __typename?: 'URLField'
                    fieldId: string
                    permissionType: Types.PermissionType
                    gofId: string
                    name: string
                    description?: string | null
                    fieldType?: Types.FieldType | null
                    isRequired: boolean
                    helpText?: string | null
                    helpTextType?: Types.HelpTextType | null
                    dynamicLabel?: string | null
                    tooltip?: string | null
                    placeholderText?: string | null
                    alternateDisplayText?: string | null
                    regexErrorMessage?: string | null
                    validationRegex?: string | null
                    isUnique: boolean
                    isDependent: boolean
                    systemFieldEnum?: Types.SystemFieldEnum | null
                    salesTemplateId: string
                    referenceId?: string | null
                    linkedSourceFieldId?: string | null
                    iconId?: string | null
                    tags: Array<Types.FieldTag>
                    stringDefaultValue?: string | null
                 }
            >
         }>
         assigneeFieldsMapping: Array<{
            __typename?: 'AssigneeFieldMapping'
            assigneeFieldId: string
            assignedOnFieldId: string
         }>
      }
   }
}

export const GetContactTemplateDocument = gql`
   query GetContactTemplate {
      getUserAppConfig {
         contactTemplate {
            ... on ContactTemplate {
               contactTemplateId
               name
               accountId
               gofs {
                  ...Sales_Crm_Web_Common_Gof_Fragment
               }
               assigneeFieldsMapping {
                  ...AssigneeFieldMapping_Fragment
               }
               identificationFieldIds
            }
         }
      }
   }
   ${Sales_Crm_Web_Common_Gof_FragmentFragmentDoc}
   ${AssigneeFieldMapping_FragmentFragmentDoc}
`
export type GetContactTemplateQueryResult = Apollo.QueryResult<
   GetContactTemplateQuery,
   GetContactTemplateQueryVariables
>
